import type { CustomFieldSchema } from 'bundles/crm/types';

export function filterByTab(currentTab: string) {
  const compClassName = currentTab === 'lease' ? 'Research::Lease' : 'Research::Sale';
  return (schema: CustomFieldSchema) => schema.modelType === compClassName;
}
